<template>
<form @submit.prevent="submitForm">
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Copy Project</p>
        </header>
        <section class="modal-card-body">
            <b-notification type="is-danger" v-if="errorMessage" :closable="false">
                {{ errorMessage }}
            </b-notification>
            <b-message type="is-info" has-icon icon-size="is-small">
                You are about to copy the project <b>{{project.name}}</b>.
                The copied project's status will be set as Draft, and you will need to verify all the
                information before publishing.
                Please provide a new name for the copied project.
            </b-message>

            <b-field label="New Name" horizontal>
                <b-input type="text" v-model="newName" required></b-input>
            </b-field>
        </section>
        <footer class="modal-card-foot">
            <button  type="button" class="button" @click="onCancelAction">Cancel</button>
            <button type="submit" class="button is-primary" :disabled="!newName || newName.length === 0 || isCopying">
                Copy Project
                <i v-if="isCopying" class="fas fa-spinner fa-spin is-small extra-margin"></i>
            </button>
        </footer>
    </div>
</form>
</template>

<script>
import moment from 'moment';
import projectService from '@/services/project-service.js';

export default {
    name: 'ProjectCopyForm',
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            errorMessage: '',
            newName: '',
            isCopying: false
        };
    },
    created () {
    },
    methods: {
        async submitForm () {
            try {
                this.isCopying = true;
                let projectCopyModel = {
                    ProjectId: this.project.id,
                    Name: this.newName,
                    EndDate: moment.utc().add(1, 'years')
                };
                let copiedProject = await projectService.copyProject(projectCopyModel);
                this.$emit('copyCompleted', copiedProject.data.id);
                this.$parent.close();
            } catch (error) {
                if (error.response && error.response.data) {
                    this.errorMessage = error.response.data;
                } else {
                    this.errorMessage = error.message;
                }
            } finally {
                this.isCopying = false;
            }
        },
        onCancelAction () {
            this.$parent.close();
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-card-foot {
    justify-content: flex-end;
}

.extra-margin {
    margin-left: 5px;
}
</style>
